import React from "react";
import ContentEditable from "react-contenteditable";
import PropTypes from "prop-types";

const EditableDiv = props => {
  const [html, setHtml] = React.useState(props.formText);

  const handleChange = event => {
    setHtml(event.target.value);
    props.trackEdits(event.target.value);
  };

  return (
    <pre>
      <ContentEditable
        html={html} // innerHTML of the editable div
        disabled={false} // use true to disable edition
        onChange={handleChange} // handle innerHTML change
      />
    </pre>
  );
};

EditableDiv.propTypes = {
  formText: PropTypes.string.isRequired,
  trackEdits: PropTypes.func.isRequired
};

export default EditableDiv;
